module.exports = __webpack_public_path__ + "static/img/20.435dbb7f.gif";